import Component from "../../../../js/assets/component.js"

class LoadingFullEarth extends Component {

  constructor(selector) {
    // set root element
    super(selector)
  }

  data() {
    return {
      'hasMinimumDurationPassed': null,
    }
  }

  reset() {
    this.$data.hasMinimumDurationPassed = null
  }

  start() {
    this.$el.removeClass('-inActive')
    this.$el.addClass('-active')

    this.reset()

    this.showAtLeastAFewSecond()
  }

  // 問い合わせのレスポンスが早かった時、ローディング演出が画面に一瞬だけ出ることになる。
  // ユーザーに演出の意図を伝えるため、レスポンスが早く返ってきても最低一定時間はローディング画面を表示する。
  showAtLeastAFewSecond() {
    const enoughDuration = 2000

    this.$data.hasMinimumDurationPassed = new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, enoughDuration)
    })
  }

  async stop() {
    await this.$data.hasMinimumDurationPassed

    this.$el.removeClass('-active')
    this.$el.addClass('-inActive')

    // transitionの完了を待つ。
    // ほんとうはtransitionendイベントの完了を待つようにしたいが、実装に手間がかかりそうなためwait
    const transitionDuration = 200
    await this.wait(transitionDuration)
  }
}

// export as singleton
const instance = new LoadingFullEarth("#loadingFullEarth")
// Object.seal(instance)
export default instance
